import AdministrationSuitability from './AdministrationSuitability'

export default AdministrationSuitability
